import { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../../../src/assets/css/global/new_header/new_header.css";
import { faAngleRight, faAngleLeft, faClock } from "@fortawesome/free-solid-svg-icons";

import truck from "../../assets/images/slotplanning/truck.svg";
import notify from "../../assets/images/slotplanning/notify.svg";
import { useGetNotificationQuery } from '../../redux/services/SPL.js';
import { CallApi } from '../common/CommonFunctions.js';
import { toast } from 'react-toastify';
import { ReactSearchAutocomplete } from 'react-search-autocomplete';
import { ReactComponent as Link } from "../../assets/images/icon_svg/link_page.svg";
import Popup from 'reactjs-popup';

const Header = ({ userInfo, page_type, oncollapsed, propData, onSearch, extraHeader, onDetails }) => {

  const isMounted = useRef(false);
  const [isIconClosed, setIsIconClosed] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [searchItems, setSearchItems] = useState([])
  const [extraInfo, setExtraInfo] = useState([]);
  const tokens = [
    'airlinetoken',
    'SAToken',
    'ULD',
    'token',
    'RFS',
    'FTM',
    'TKM',
    'EMAIL',
    'ASR',
    'airlinetoken',
    'service_recovery_token',
    'Trucking',
    'SPL',
    'QMS',
    'TEMAIL',
    'TTRACKER',
    'DVR',
    'ServerIWI',
    'NO_TOKEN',
    'QUT'
  ];
  const tokenKey = tokens.find(t => localStorage.getItem(t))
  const userName = localStorage.getItem('User');
  const dTitle = localStorage.getItem('DetailsTitle');
  // const extraHeaderInfo = JSON.parse(localStorage.getItem('extraHeader'));
  const heading = {
    SPL: 'Slotplanning',
    ASR: 'Service Recovery',
  }
  const handleIconClick = () => {
    const value = !isIconClosed
    setIsIconClosed(value);
    document.body.classList.toggle('sidebar-collapsed');
    oncollapsed(value)
  };

  const fetchSearch = (data) => {
    // console.log('data', data);

    CallApi({
      endPoint: propData?.search?.endPoint,
      payload: data?.payload,
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        if (res.data.response_code === 200) {
          const transformedData = innerData.map(name => ({
            id: name.service_recovery_id,
            name: name.master_airway_bill
          }));
          setSearchItems(transformedData)
        } else {
          // toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => console.error(msg)
    });
  };
  useEffect(() => {
    if (isMounted.current) return;
    document.body.classList.toggle('sidebar-collapsed');
    if (propData?.search) fetchSearch(propData?.search)
    isMounted.current = true;
  }, [propData]);

  // useEffect(() => {
  //   if (extraHeaderInfo?.length) {
  //     setExtraInfo(extraHeaderInfo)
  //   } else {
  //     setExtraInfo([])
  //   }
  // }, [extraHeaderInfo])

  // const { data, isFetching, refetch } = useGetNotificationQuery({
  //   type: 'airline'
  // });

  // useEffect(() => {
  //   if (data?.response_data) {
  //     const innerData = data.response_data;
  //     // console.log('innerData', innerData)
  //   }
  // }, [data]);

  // useEffect(() => {

  // },[propData])

  const searchChange = (e) => {
    const { name, value } = e.target;
    if (name === 'master_airway_bill') {
      let input = e.target.value;
      input = input.replace(/[^\d]/g, '');

      if (input.length > 3 && input.length <= 7) {
        input = input.slice(0, 3) + '-' + input.slice(3);
      } else if (input.length > 7) {
        input =
          input.slice(0, 3) +
          '-' +
          input.slice(3, 7) +
          ' ' +
          input.slice(7, 11);
      }
      setSearchValue(input)
    }
    if (name === 'master_airway_bill' && value.length !== 13) return

    CallApi({
      endPoint: propData?.search?.endPoint,
      payload: { ...propData?.search?.payload, [name]: value },
      onSuccess: (res) => {
        const innerData = res.data.response_data;
        if (res.data.response_code === 200) {
          onSearch(innerData)
        } else {
          toast.error(res.data.response_msg)
        }
      },
      onError: (msg) => console.error(msg)
    });
  }
  const filteredSearchItems = searchItems.filter((item) => {
    const inputDigits = searchValue?.replace(/\D/g, '');
    const itemDigits = item.name?.replace(/\D/g, '');

    return itemDigits?.startsWith(inputDigits);
  });
  // new 

  const formatInput = (value) => {
    // remove non-digits
    let digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length > 3) {
      return digits.slice(0, 3) + '-' + digits.slice(3);
    }

    // if (digits.length > 3 && digits.length <= 7) {
    //   return digits.slice(0, 3) + '-' + digits.slice(3);
    // } 
    // else if (digits.length > 7) {
    //   return (
    //     digits.slice(0, 3) +
    //     '-' +
    //     digits.slice(3, 7) +
    //     ' ' +
    //     digits.slice(7)
    //   );
    // }
    return digits;
  };

  const handleOnSearch = (string, results) => {
    console.log('$$', string, results)
    if (/^[0-9\s-]*$/.test(string)) {
      let digits = string.replace(/\D/g, '');
      digits = digits.slice(0, 11);
      setSearchValue(formatInput(digits));
    }
    // const formatted = formatInput(string);
    // setSearchValue(formatted);

  }

  const handleOnHover = (result) => {
    console.log(result)
  }

  const handleOnSelect = async (item) => {
    // the item selected
    // console.log(item)
    onSearch(item)
    setSearchValue('')
    // try {
    //   const res = await withRFSToken.post(ULDSEARCHDETAILS, { uld_number: item.name });
    //   if (res.data.response_code == 200) {
    //     localStorage.removeItem('MHistory');
    //     const storageData = {
    //       ULD: res.data.response_data,  // ULD Details section
    //       Form: {}  // Empty form section
    //     };
    //     localStorage.setItem('MHistory', JSON.stringify(storageData));
    //     localStorage.setItem('tab', initialTab);
    //     window.location.href = '/ULDControl/MovementHistory'
    //   }

    // } catch (error) {
    //   console.error('Error fetching data:', error);
    // }
  }

  const handleOnFocus = () => {
    // console.log('Focused')
  }

  useEffect(() => {
    const input = document.querySelector('.header-search input');
    if (input) {
      input.maxLength = 12;
    }
  }, []);
  const loadDetails = (id) => {
    onDetails({ service_recovery_id: id, master_airway_bill: dTitle })

  }
  return (
    <>
      <div className='d-flex position-relative header'>
        <div className="header-left">
          <span className="tglicon">
            <FontAwesomeIcon
              icon={isIconClosed ? faAngleRight : faAngleLeft}
              className={`toggle-btn ${isIconClosed ? "rotate" : ""}`}
              onClick={handleIconClick}
            />
          </span>
          <h2>
            {propData?.title || heading[tokenKey]}
            <span>{propData?.subTitle}</span>
            {dTitle && <span>{dTitle}</span>}
            {extraHeader?.length ? <span>
              <Popup
                trigger={
                  <span className="header-extra">
                    +{extraHeader.length}
                  </span>
                }
                className="poparrow"
                position="bottom"
                on={['hover', 'focus']}
                arrow={true}
              >
                <div className='shipmentPopup'>

                  <h3 className="text-center">Other Recovery Cases  <span>{dTitle}</span> </h3>

                  {extraHeader?.map((eh, index) => (
                    <div className="segments-block" >
                      <span>{eh.irregularity_type.join(', ')} </span> |
                      <span>{eh.reporting_station} </span> |
                      <span className={`ms-2 me-4 ${eh.is_recovery_closed ? 'green_btn' : 'gray_btn'}`}> {eh.is_recovery_closed ? 'Closed' : 'Open'} </span>
                      <button onClick={() => loadDetails(eh.service_recovery_id)}>view Case <Link /> </button>
                    </div>

                  ))}
                </div>
              </Popup>
            </span> : <></>}
          </h2>
        </div>
        <div className="header-right">
          <div className="truk-dv position-relative">
            {propData?.search &&
              <>
                <ReactSearchAutocomplete
                  items={filteredSearchItems}
                  onSearch={handleOnSearch}
                  onHover={handleOnHover}
                  onSelect={handleOnSelect}
                  onFocus={handleOnFocus}
                  inputSearchString={searchValue}
                  inputProps={{ maxLength: 11 }}
                  autoFocus
                  className="header-search hdr-tp-src"
                  placeholder={propData?.search?.placeholder}
                // formatResult={formatResult}
                />
                {/* <input
                  className="header-search hdr-tp-src"
                  placeholder={propData?.search?.placeholder}
                  name={propData?.search?.fieldName}
                  onChange={searchChange}
                  value={searchValue}
                  maxLength={13}
                /> */}
                <span className="trkicon">
                  {/* {<img src={truck} className="menu-icon" />} */}
                  {propData?.search?.icon}
                </span>
              </>
            }
          </div>
          <span className="bldv">
            {/* <FontAwesomeIcon icon={faBell} className="bell" /> */}
            {<img src={notify} className="menu-icon bell" />}
          </span>
          <div className="user-n">
            <h4>WELCOME</h4>
            <h3>{userInfo?.user_name}</h3>
          </div>
        </div>
      </div>
    </>
  )
}

export default Header